// GeneralViews
import NotFound from '../components/GeneralViews/NotFoundPage.vue'
// Dashboard pages
import Start from 'src/components/UIComponents/Custom/Start'
import Obmen from '../components/UIComponents/Custom/Obmen'
import Catalog from '../components/UIComponents/Custom/Catalog'
import Order from '../components/UIComponents/Custom/Order'
import OrdersList from '../components/UIComponents/Custom/OrdersList'
import First from '../components/UIComponents/Custom/First'
import Settings from '../components/UIComponents/Custom/Settings'
import Deeplink from '../components/UIComponents/Custom/Deeplink'

const routes = [
  {
    path: '/',
    name: 'Start',
    component: Start
  },
  {
    path: '/dplink',
    name: 'DpLink',
    component: Deeplink
  },
  {
    path: '/first',
    name: 'First',
    component: First
  },
  {
    path: '/settings',
    name: 'Settings',
    component: Settings
  },
  {
    path: '/obmen',
    name: 'Obmen',
    component: Obmen
  },
  {
    path: '/catalog',
    name: 'Catalog',
    component: Catalog
  },
  {
    path: '/order',
    name: 'Order',
    component: Order
  },
  {
    path: '/orderslist',
    name: 'OrdersList',
    component: OrdersList
  },
  {path: '*', component: NotFound}
]

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
 function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes



// WEBPACK FOOTER //
// ./src/routes/routes.js